import React from "react";
import CourseTile from "../../AllCourses/components/CourseTile";
import { CourseResource } from "../../../stores/CoursesStore/Types";

interface Props {
  courses: CourseResource[];
  userIsInUk?: boolean;
}

const courseRange = (courseCount: number) => {
  if (courseCount === 0) {
    return "00";
  }

  return `01–${courseCount.toString().padStart(2, "0")}`;
};

const Courses = ({ courses, userIsInUk }: Props) => {
  return (
    <section className="courses" id="courses" aria-labelledby="courses-title">
      <div className="container">
        <div className="category-head">
          <span className="category-num">{courseRange(courses.length)}</span>

          <h2 className="category-title" id="courses-title">
            The courses
          </h2>

          <span className="category-count">
            {courses.length} courses &middot; all CPD-accredited
          </span>
        </div>

        <div className="courses-grid">
          {courses.map((course) => (
            <CourseTile
              course={course}
              key={course.id}
              userIsInUk={userIsInUk}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Courses;
